import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RegExpSwift extends Vue {

	regExpSwift: RegExp = /^(([A-Z])|([0-9])|(,)|(-)|( )|(\.)|(\()|(\))|(\/)|(=)|(\')|(\+)|(:)|(\?)|(\!)|(\")|(%)|(\&)|(\*)|(<)|(>)|(;)|(\\))+$/g

	getRegExpSwift(): RegExp {
		return this.regExpSwift;
	}

}